import { getOrganizeTree } from '@/api/permission/organize';
import { getDepartmentSelector } from '@/api/permission/department';
import { getDictionaryType } from '@/api/systemData/dictionary';
var state = {
  companyTree: [],
  depTree: [],
  dicTree: [],
  formItemList: [],
  subTable: [],
  hasTable: false,
  relationData: {}
};
var mutations = {
  SET_COMPANY_TREE: function SET_COMPANY_TREE(state, companyTree) {
    state.companyTree = companyTree;
  },
  SET_DEP_TREE: function SET_DEP_TREE(state, depTree) {
    state.depTree = depTree;
  },
  SET_DIC_TREE: function SET_DIC_TREE(state, dicTree) {
    state.dicTree = dicTree;
  },
  UPDATE_FORMITEM_LIST: function UPDATE_FORMITEM_LIST(state, list) {
    state.formItemList = list;
  },
  UPDATE_SUB_TABLE: function UPDATE_SUB_TABLE(state, subTable) {
    state.subTable = subTable;
  },
  SET_TABLE: function SET_TABLE(state, val) {
    state.hasTable = val;
  },
  UPDATE_RELATION_DATA: function UPDATE_RELATION_DATA(state, val) {
    state.relationData = val;
  }
};
var actions = {
  getCompanyTree: function getCompanyTree(_ref) {
    var state = _ref.state,
      commit = _ref.commit;
    return new Promise(function (resolve, reject) {
      if (!state.companyTree.length) {
        getOrganizeTree().then(function (res) {
          commit('SET_COMPANY_TREE', res.data.list);
          resolve(res.data.list);
        }).catch(function (error) {
          reject(error);
        });
      } else {
        resolve(state.companyTree);
      }
    });
  },
  getDepTree: function getDepTree(_ref2) {
    var state = _ref2.state,
      commit = _ref2.commit;
    return new Promise(function (resolve, reject) {
      if (!state.depTree.length) {
        getDepartmentSelector().then(function (res) {
          commit('SET_DEP_TREE', res.data.list);
          resolve(res.data.list);
        }).catch(function (error) {
          reject(error);
        });
      } else {
        resolve(state.depTree);
      }
    });
  },
  getDicTree: function getDicTree(_ref3) {
    var state = _ref3.state,
      commit = _ref3.commit;
    return new Promise(function (resolve, reject) {
      if (!state.dicTree.length) {
        getDictionaryType().then(function (res) {
          commit('SET_DIC_TREE', res.data.list);
          resolve(res.data.list);
        }).catch(function (error) {
          reject(error);
        });
      } else {
        resolve(state.dicTree);
      }
    });
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};